import {ModelsInterfaces} from '@namespaces/models.namespace';

export class ObjectModal {
    public readonly id: number;
    public readonly number: string;
    public readonly title: string;
    public readonly isRoot: boolean;
    public readonly parent_id: number;
    public children: ObjectModal[] = [];

    /**
     * Выбран
     */
    public selected = false;

    /**
     * Раскрыт для уточнения дочерних объектов
     */
    public expanded = false;

    constructor(object: ModelsInterfaces.Object) {
        this.id = object.id;
        this.number = object.number;
        this.title = object.title;
        this.parent_id = object.parent_id;
        this.isRoot = object.lvl <= 2;

        if (object.childs && object.childs.length) {
            this.children = object.childs.map(o => new ObjectModal(o));
        }
    }

    select(value = true): void {
        this.selected = value;

        if (!this.selected) {
            this.expand(false);
            this.children.forEach(item => item.select(false));
        }
    }

    /**
     * Раскрыть объект
     * @param value
     */
    expand(value = true) {
        this.expanded = value;
    }

    toggleExpand() {
        this.expanded = !this.expanded;
    }

    /**
     * Выбран ли объект целиком?
     * Объект выбран целиком, если выбран он сам и либо выбраны вообще все его подобъекты,
     * либо ни один из его подобъектов не выбран
     */
    get wholeSelected() {
        return this.selected &&
            (
                this.children.every(item => item.selected && item.wholeSelected) ||
                this.children.every(item => !item.selected && !item.wholeSelected)
            );
    }

    /**
     * Получить номер выбранного объекта.
     *
     * Возвращается либо номер всего объекта, если он выбран целиком,
     * либо номера выбранных подобъектов
     */
    getSelectedNumbers() {
        if (this.wholeSelected) {
            return this.number;
        }

        if (this.children.length) {
            const numbers = this.children.map(item => item.getSelectedNumbers()).filter(v => Boolean(v));
            return numbers && numbers.length ? numbers.join(', ') : null;
        }

        return null;
    }

    restoreSelectionValue(numbers: string[]) {
        this.expanded = false;

        this.children.forEach(item => item.restoreSelectionValue(numbers));

        this.select(Boolean(numbers.indexOf(this.number) >= 0 || this.children.some(item => item.selected)));
    }
}
